import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import SetupGuide from "./SetupGuide";

const empty = { label: "", adAccountId: "", pageId: "", instagramUserId: "", accessToken: "" };

function initial(connection) {
  return connection
    ? {
        label: connection.label || "",
        adAccountId: connection.adAccountId || "",
        pageId: connection.pageId || "",
        instagramUserId: connection.instagramUserId || "",
        accessToken: "",
      }
    : empty;
}

/** Mounted only while open, so each open starts from the account being edited. */
export default function ConnectionFormDialog({ connection, saving, onSave, onClose }) {
  const [form, setForm] = useState(() => initial(connection));
  const editing = Boolean(connection);
  const set = (name) => (e) => setForm({ ...form, [name]: e.target.value });
  const complete =
    form.label.trim() &&
    form.adAccountId.trim() &&
    form.pageId.trim() &&
    (editing || form.accessToken.trim());

  return (
    <Dialog open onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>{editing ? `Edit ${connection.label}` : "Add a Meta account"}</DialogTitle>
      <DialogContent className="space-y-3">
        <p className="pt-2 text-sm text-app-text-secondary">
          Each account has its own ad account, page and token, so you can run pages that belong to
          different Facebook logins side by side.
        </p>
        <TextField
          label="Name"
          value={form.label}
          onChange={set("label")}
          fullWidth
          size="small"
          helperText="Shown in the account picker, e.g. Kothar Australia"
          inputProps={{ maxLength: 100 }}
        />
        <TextField
          label="Ad account id"
          value={form.adAccountId}
          onChange={set("adAccountId")}
          fullWidth
          size="small"
          helperText="Digits, with or without act_"
        />
        <TextField
          label="Facebook page id"
          value={form.pageId}
          onChange={set("pageId")}
          fullWidth
          size="small"
        />
        <TextField
          label="Instagram user id (optional)"
          value={form.instagramUserId}
          onChange={set("instagramUserId")}
          fullWidth
          size="small"
        />
        <TextField
          label="Access token"
          type="password"
          autoComplete="off"
          value={form.accessToken}
          onChange={set("accessToken")}
          fullWidth
          size="small"
          helperText={
            editing
              ? "Stored encrypted and never shown. Leave blank to keep the saved token."
              : "Stored encrypted and never shown again."
          }
        />
        <SetupGuide />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" disabled={!complete || saving} onClick={() => onSave(form)}>
          {saving ? "Saving…" : "Save and test"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
